import React, { FC } from "react";

// Components
import TableColumn from "./TableColumn";

// Data
const column_headers = [
  "Medical expenses",
  "Accident insurance",
  "Personal belongings and luggage",
  "Responsibility in ordinary civic life",
  "Hospital stay",
  "Above-standard assistance and legal services",
];

const packages = [
  {
    name: "Basic",
    price: 9,
    items: {
      medicalExpenses: 200000,
      accidentInsurance: false,
      belongingsLuggage: null,
      civicLifeResponsibility: null,
      hospitalStay: null,
      aboveAssistance: false,
    },
  },
  {
    name: "Premium",
    price: 30,
    items: {
      medicalExpenses: 1000000,
      accidentInsurance: true,
      belongingsLuggage: 1000,
      civicLifeResponsibility: 400000,
      hospitalStay: null,
      aboveAssistance: false,
    },
  },
  {
    name: "Exclusive",
    price: 49,
    items: {
      medicalExpenses: 4000000,
      accidentInsurance: true,
      belongingsLuggage: 2000,
      civicLifeResponsibility: 2000,
      hospitalStay: "$100/day, max.$1000",
      aboveAssistance: true,
    },
  },
];

const Table: FC<{
  packages: any;
  modalToggleHandler: any;
}> = (props) => {
  return (
    <div className="table">
      {props.packages.map((columnPackage: any) => (
        <TableColumn
          columnHeaders={column_headers}
          columnItems={columnPackage}
          key={columnPackage.name}
          modalToggleHandler={props.modalToggleHandler}
        />
      ))}
    </div>
  );
};

export default Table;
